// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import * as analytics from 'analytics/Analytics';
import BenchlingConfig from 'BenchlingConfig';
import * as biojs from 'BioJS';
import {NucleotideType} from 'biojs/BioConstants';
import {SequencePrimerAttributes} from 'biojs/SequencePrimer';
import {Sequence} from 'components/Sequence';
import DataConnector from 'connect/DataConnector';
import * as CrisprConstants from 'constants/CRISPRConstants';
import {
  CRISPRAnalysis,
  CRISPRAnalysisSequenceAttributes,
  CRISPRGuide,
  CRISPRRegion,
  GuideGroupSort,
} from 'constants/CRISPRConstants';
import {Genome} from 'constants/GenomeConstants';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import {SequenceVersion} from 'constants/SequenceConstants';
import {SequenceFileState} from 'FileStates';
import Annotation from 'molbio/annotations/backbone/Annotation';
import SearchDNAData from 'molbio/biological-search/SearchDNAData';
import DoenchScore from 'molbio/crispr/doenchScore';
import {openBulkAssembleDNA} from 'nav/CreateDropdownActions';
import notifications from 'notifications';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import GenomeStore from 'stores/GenomeStore';
import getTestProps from 'test/lib/cypress/getTestProps';
import FormInput from 'ui-library/bs/FormInput';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import ModalAnchor from 'ui-library/ModalAnchor';
import {ElementFormEvent, InputChangeEvent} from 'util/Types';

import CRISPRAssemblyTabState from './assembly/CRISPRAssemblyTabState';
import BaseEditGuideGroupTable from './BaseEditGuideGroupTable';
// @ts-expect-error
import CRISPRAnalysisActions from './CRISPRAnalysisActions';
import CRISPRAnalysisStore from './CRISPRAnalysisStore';
import CRISPRAnalysisTabBlocked from './CRISPRAnalysisTabBlocked';
import CRISPRAnalysisTabState from './CRISPRAnalysisTabState';
import CRISPRGuideGroupTable from './CRISPRGuideGroupTable';
import CRISPRRegionTable from './CRISPRRegionTable';
import * as CRISPRUtil from './CRISPRUtil';
import SettingsModal from './SettingsModal';

const {DESIGN_TYPE, OFF_TARGET_SCORE_TYPE} = CrisprConstants;
const {DOENCH_GUIDE_SIZE} = DoenchScore;

class CRISPRAnalysisConnector extends DataConnector<
  CRISPRAnalysisOptionsProps,
  CRISPRAnalysisOptionsEnhancedProps
> {
  shouldSubscribeToRedux = false;
  stores = [CRISPRAnalysisStore];

  enhanceProps(): CRISPRAnalysisOptionsEnhancedProps {
    const {analyses, analysisLoading, selectedRegionsMap, guideGroupSortMap} =
      this.crisprAnalysisStore().getState();
    const analysis = analyses[this.props.analysisId];
    return {
      analysis: this.crisprAnalysisStore().isFullAnalysis(analysis) ? analysis : null,
      analysisLoading,
      selectedRegions: selectedRegionsMap[this.props.analysisId],
      guideGroupSort: guideGroupSortMap[this.props.analysisId],
    };
  }
}

interface CRISPRAnalysisOptionsProps {
  allowEdits: boolean;
  findGuidesParams: {
    search: SearchDNAData;
    sequence: Sequence;
  };
  analysisId: string;
}
interface CRISPRAnalysisOptionsEnhancedProps {
  analysis: CRISPRAnalysis | null;
  analysisLoading: boolean;
  selectedRegions: {[regionId: string]: boolean};
  guideGroupSort: GuideGroupSort;
}
interface CRISPRAnalysisOptionsState {
  name?: string;
  showSettingsModal: boolean;
}

class CRISPRAnalysisOptions extends React.Component<
  CRISPRAnalysisOptionsProps & CRISPRAnalysisOptionsEnhancedProps,
  CRISPRAnalysisOptionsState
> {
  state: CRISPRAnalysisOptionsState = {
    name: undefined,
    showSettingsModal: false,
  };

  componentDidMount(): void {
    if (this.props.analysis != null) {
      this.setState({name: this.props.analysis.name});
    }
  }

  componentDidUpdate(
    prevProps: CRISPRAnalysisOptionsProps & CRISPRAnalysisOptionsEnhancedProps,
    prevState: CRISPRAnalysisOptionsState
  ): void {
    if (prevProps.analysis == null && this.props.analysis != null) {
      this.setState({name: this.props.analysis.name});
    }
  }

  saveName = (e: ElementFormEvent): void => {
    e.preventDefault();
    CRISPRAnalysisActions.update(
      this.props.analysis!.id,
      {name: this.state.name},
      this.props.findGuidesParams
    );
  };

  isRunningOT = (): boolean => {
    if (this.props.analysis == null) {
      return false;
    }
    for (const region of Array.from(this.props.analysis.regions)) {
      if (this.props.selectedRegions[region.id]) {
        for (const guide of Array.from(region.guides)) {
          if (guide.offTargetScore == null) {
            return true;
          }
        }
      }
    }
    return false;
  };

  render(): JSX.Element {
    return (
      <ul className="nav navbar-nav form-inline">
        <li>
          <form onSubmit={this.saveName}>
            <FormInput
              style={{width: 200}}
              type="text"
              required={true}
              disabled={this.state.name == null || !this.props.allowEdits}
              value={this.state.name}
              onChange={(e: InputChangeEvent): void => {
                this.setState({name: e.target.value});
              }}
            />
            <Button
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
              size={ButtonSize.MINI}
              type="submit"
              disabled={this.state.name == null || this.props.analysisLoading || !this.props.allowEdits}
              text={this.props.analysisLoading ? 'Saving...' : 'Save'}
            />
          </form>
        </li>
        <li className="pull-right">
          <Button
            buttonStyle={ButtonStyle.TERTIARY_GRAY}
            size={ButtonSize.MINI}
            onClick={() => {
              this.setState({showSettingsModal: true});
            }}
            disabled={this.props.analysis == null}
            text="Settings"
            dataTestAttrs={{component: 'CRISPRAnalysisTabView', element: 'settingsButton'}}
          />
        </li>
        <li className="pull-right">
          {this.isRunningOT() ? (
            <div
              className="spinner"
              {...getTestProps({component: 'CRISPRAnalysisTabView', element: 'OTRunningSpinner'})}
            />
          ) : undefined}
        </li>
        <ModalAnchor open={this.state.showSettingsModal}>
          <SettingsModal
            allowEdits={this.props.allowEdits}
            analysis={this.props.analysis!}
            analysisLoading={this.props.analysisLoading}
            onRequestClose={() => {
              this.setState({showSettingsModal: false});
            }}
            findGuidesParams={this.props.findGuidesParams}
          />
        </ModalAnchor>
      </ul>
    );
  }
}

const ConnectedCRISPRAnalysisOptions = CRISPRAnalysisConnector.connect(CRISPRAnalysisOptions);

class CRISPRAnalysisOptionsView extends Backbone.View<CRISPRAnalysisTabState> {
  static initClass(): void {
    this.prototype.className = 'navbar';
  }

  initialize(options: unknown): void {
    const sequence = this.model.sequence();
    const _sequence = sequence._sequence();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(sequence, 'change:writable change:permissions change:currentVersion', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(_sequence, 'change:locked', this.render);
  }

  render(): this {
    renderToDOM(
      <ConnectedCRISPRAnalysisOptions
        allowEdits={this.model.sequence().allowFeatureEdits()}
        analysisId={this.model.analysisId()}
        findGuidesParams={{sequence: this.model.sequence(), search: this.model.search()}}
      />,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<CRISPRAnalysisTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
CRISPRAnalysisOptionsView.initClass();

interface CRISPREnsureScoredProps {
  analysis: CRISPRAnalysis;
}

// Simple component that ensures all regions are scored on mount.
class CRISPREnsureScored extends React.Component<CRISPREnsureScoredProps> {
  componentDidMount(): void {
    const missingOnTargetScore = this.props.analysis.regions.filter((region) =>
      region.guides.some((guide: CRISPRGuide) => guide.onTargetScore == null)
    );
    // eslint-disable-next-line no-restricted-syntax
    const regionIds = _.pluck(missingOnTargetScore, 'id');
    CRISPRAnalysisActions.analyzeOnTargetBulk(this.props.analysis.id, regionIds);
    for (const region of Array.from(this.props.analysis.regions)) {
      const needsOffTargetScore = region.guides.some((guide: CRISPRGuide) => guide.offTargetScore == null);
      if (needsOffTargetScore) {
        CRISPRAnalysisActions.analyzeRegionOffTarget(this.props.analysis.id, region.id);
      }
    }
  }

  render(): null {
    return null;
  }
}

class CRISPRAnalysisTabConnector extends DataConnector<
  CRISPRAnalysisTabProps,
  CRISPRAnalysisTabEnhancedProps
> {
  shouldSubscribeToRedux = false;
  stores = [CRISPRAnalysisStore, GenomeStore];

  enhanceProps(): CRISPRAnalysisTabEnhancedProps {
    const {
      analyses,
      regionLoading,
      regeneratingAnalysis,
      selectedRegionsMap,
      guideGroupSortMap,
      selectedGuideGroupsMap,
      originalSequenceVersionMap,
    } = this.crisprAnalysisStore().getState();
    const analysis = analyses[this.props.analysisId];
    return {
      analysis: this.crisprAnalysisStore().isFullAnalysis(analysis) ? analysis : null,
      regionLoading,
      regeneratingAnalysis,
      selectedRegions: selectedRegionsMap[this.props.analysisId],
      guideGroupSort: guideGroupSortMap[this.props.analysisId],
      selectedGuideGroups: selectedGuideGroupsMap[this.props.analysisId],
      originalSequenceVersion: originalSequenceVersionMap[this.props.analysisId],
      genomes: this.genomeStore().getGenomes(),
    };
  }
}

interface CRISPRAnalysisTabProps {
  allowEdits: boolean;
  annotations: Array<{start: number; end: number; name: string}>;
  sequencePrimers: Array<{start: number; end: number; strand: StrandOfDoubleStranded}>;
  findGuidesParams: {
    search: SearchDNAData;
    sequence: Sequence;
  };
  openAssemblyTab: (analysis: unknown, guides: Array<CRISPRGuide>) => void;
  selection: {start: number; end: number | null};
  setSelection: (start: number, end: number) => void;
  sequence: CRISPRAnalysisSequenceAttributes;
  saveGuidePrimers: (folderId: string, nucleotideType: NucleotideType, tagSchemaId: string | null) => void;
  showGuidePrimers: (guides: Array<CRISPRGuide>) => void;
  openSequenceVersion: (versionId: number) => void;
  openExpandedTranslationView: () => void;
  versionIds: Array<number>;
  analysisId: string;
}
interface CRISPRAnalysisTabEnhancedProps {
  analysis: CRISPRAnalysis | null;
  regionLoading: boolean;
  regeneratingAnalysis: boolean;
  selectedRegions: {[regionId: string]: boolean};
  guideGroupSort: {
    key: string;
    reverse: boolean;
    offset: number;
  };
  selectedGuideGroups: {[guideGroupKey: string]: boolean};
  originalSequenceVersion?: SequenceVersion;
  genomes: Array<Genome>;
}
class CRISPRAnalysisTab extends React.Component<CRISPRAnalysisTabProps & CRISPRAnalysisTabEnhancedProps> {
  getGuideGroupSize = (): 1 | 2 => {
    switch (this.props.analysis!.designType) {
      case DESIGN_TYPE.SINGLE:
        return 1;
      case DESIGN_TYPE.BASE_EDIT:
        return 1;
      case DESIGN_TYPE.PAIRED:
        return 2;
      default:
        return undefined as never;
    }
  };

  getGuideGroups = (): Array<Array<CRISPRGuide>> => {
    const guideGroupSize = this.getGuideGroupSize();
    const guideGroups = [];
    // eslint-disable-next-line no-var, vars-on-top
    for (var region of Array.from(this.props.analysis!.regions)) {
      if (!this.props.selectedRegions[region.id]) {
        continue;
      }
      for (
        let i = 0, end = region.guides.length, step = guideGroupSize, asc = step > 0;
        asc ? i < end : i > end;
        i += step
      ) {
        let guideGroup = region.guides.slice(i, i + guideGroupSize);
        // eslint-disable-next-line no-restricted-syntax, no-loop-func
        guideGroup = guideGroup.map((guide: CRISPRGuide) => _.extend({}, guide, {regionId: region.id}));
        guideGroups.push(guideGroup);
      }
    }
    return guideGroups;
  };

  genomeFromStore = (): Genome =>
    // Store genome has full information.
    _.findWhere(this.props.genomes, {ensemblName: this.props.analysis!.genome.ensemblName})!;

  renderWarnings = (): JSX.Element | null => {
    if (this.props.analysis!.regions.length === 0) {
      return null;
    }

    if (
      this.props.analysis!.regions.some(
        ({genomeRegionChromosome}: CRISPRRegion) => genomeRegionChromosome == null
      )
    ) {
      return (
        <div className="alert alert-warning" key="genome-region-warning">
          {"You don't have a genome region set above, so "}
          <strong>scores may not match scores from other sites</strong>
          {
            '. Benchling uses the genome region to locate your target region and to ignore potential off-target '
          }
          sites in that part of the genome.
        </div>
      );
    }

    if (this.props.analysis!.searchSoftMaskedBases) {
      return (
        <div className="alert alert-warning" key="masked-region-warning">
          {'You included masked regions in the off-target search (under Settings above), so '}
          <strong>scores may not match scores from other sites</strong>
          {'. The common default is to skip repeats / low complexity regions '}
          when doing off-target search.
        </div>
      );
    }

    return null;
  };

  renderAzimuthOnTargetError = (): JSX.Element | null => {
    if (
      this.props.analysis!.useAzimuthOnTargetScore &&
      (this.props.sequence.circular || this.props.analysis!.guideLength < DOENCH_GUIDE_SIZE)
    ) {
      return (
        <div className="alert alert-danger" key="azimuth-circular-error">
          {`The new on-target score from Doench, Fusi et al. (2016) is only defined for non-circular sequences, \
  non-degenerate guides, and guides 20 bp or longer. To generate on-target activity scores, please \
  modify your analysis to use the old on-target score.`}
        </div>
      );
    }

    return null;
  };

  shouldRenderOnTargetAzimuthInfo = (): boolean => {
    if (this.props.analysis!.useAzimuthOnTargetScore) {
      for (const region of Array.from(this.props.analysis!.regions)) {
        for (const guide of Array.from(region.guides)) {
          if (guide.onTargetScore != null && !guide.usedFullModel) {
            return true;
          }
        }
      }
    }
    return false;
  };

  renderOnTargetAzimuthInfo = (): JSX.Element | null => {
    if (!this.shouldRenderOnTargetAzimuthInfo()) {
      return null;
    }
    return (
      <div className="alert alert-info" key="azimuth-on-target-info">
        <p>
          {'The '}
          <a href={CrisprConstants.URLS.CFD_SCORE_PAPER} target="_blank" rel="noreferrer">
            Doench, Fusi et al. (2016)
          </a>{' '}
          paper publishes two models for scoring guides - one that includes the position of the cut within the
          translated gene and a simpler model that looks only at the guide sequence.
        </p>
        <p>
          Scores marked with an * below indicate that they were computed using the model without gene position
          information. To use the model that includes gene position in the scoring function:
          <li>the guide's cut must be within a translated region of the sequence</li>
          <li>
            {'all of the translations on the sequence must be in a single '}
            <a onClick={this.props.openExpandedTranslationView}>
              <strong>translation group</strong>
            </a>
          </li>
        </p>
      </div>
    );
  };

  renderCFDOffTargetInfo = (): JSX.Element | null => {
    if (this.props.analysis!.offTargetScoreType !== OFF_TARGET_SCORE_TYPE.CFD) {
      return null;
    }
    return (
      <div className="alert alert-info" key="cfd-off-target-info">
        <p>
          {'When using the CFD score, Benchling uses a different method for ranking and evaluating the '}
          {'relative quality of guides from that of '}
          <a
            href="https://portals.broadinstitute.org/gpp/public/software/sgrna-scoring-help"
            rel="noopener noreferrer"
            target="_blank"
          >
            the Broad Institute's sgRNA design tool.
          </a>
        </p>
        <p>
          {'The off-target score for a given guide is calculated by aggregating the scores for each of the '}
          {'guide\'s off-targets, using the same "Aggregate Score by Guide" formula from '}
          <a href={CrisprConstants.URLS.HSU_OFF_TARGET_PAPER} rel="noopener noreferrer" target="_blank">
            Hsu et al. (2013).
          </a>
        </p>
      </div>
    );
  };

  render(): JSX.Element {
    if (this.props.analysis == null) {
      return <div className="faded text-center u-small-spacing-top">Loading...</div>;
    }

    if (this.props.analysis.originalBases !== this.props.sequence.bases || this.props.regeneratingAnalysis) {
      return (
        <CRISPRAnalysisTabBlocked
          allowEdits={this.props.allowEdits}
          analysis={this.props.analysis}
          findGuidesParams={this.props.findGuidesParams}
          openSequenceVersion={this.props.openSequenceVersion}
          originalSequenceVersion={this.props.originalSequenceVersion}
          regeneratingAnalysis={this.props.regeneratingAnalysis}
          sequence={this.props.sequence}
          versionIds={this.props.versionIds}
        />
      );
    }

    return (
      <div>
        <CRISPREnsureScored analysis={this.props.analysis} />
        <CRISPRRegionTable
          allowEdits={this.props.allowEdits}
          analysisId={this.props.analysis.id}
          annotations={this.props.annotations}
          // eslint-disable-next-line no-restricted-syntax
          findGuidesParams={_.extend({}, this.props.findGuidesParams, {analysis: this.props.analysis})}
          genome={this.genomeFromStore()}
          regionLoading={this.props.regionLoading}
          regions={this.props.analysis.regions}
          selectedRegions={this.props.selectedRegions}
          selection={this.props.selection}
          sequence={this.props.sequence}
          setSelection={this.props.setSelection}
        />
        {(() => {
          if (this.props.analysis.designType === DESIGN_TYPE.BASE_EDIT) {
            return [
              <hr key="horizontal-rule" />,
              <BaseEditGuideGroupTable
                key="guide-group-table"
                allowEdits={this.props.allowEdits}
                analysis={this.props.analysis}
                guideGroups={this.getGuideGroups()}
                guideGroupSize={this.getGuideGroupSize()}
                openAssemblyTab={this.props.openAssemblyTab}
                sequence={this.props.sequence}
                sequencePrimers={this.props.sequencePrimers}
                selection={this.props.selection}
                setSelection={this.props.setSelection}
                saveGuidePrimers={this.props.saveGuidePrimers}
                showGuidePrimers={this.props.showGuidePrimers}
                guideGroupSort={this.props.guideGroupSort}
                selectedGuideGroups={this.props.selectedGuideGroups}
              />,
            ];
          } else if (this.props.analysis.regions.length > 0) {
            return [
              <hr key="horizontal-rule" />,
              // TODO(T5649): These warnings should move into the table components.
              this.renderWarnings(),
              this.renderCFDOffTargetInfo(),
              this.renderAzimuthOnTargetError(),
              this.renderOnTargetAzimuthInfo(),
              <CRISPRGuideGroupTable
                key="guide-group-table"
                allowEdits={this.props.allowEdits}
                analysis={this.props.analysis}
                guideGroups={this.getGuideGroups()}
                guideGroupSize={this.getGuideGroupSize()}
                openAssemblyTab={this.props.openAssemblyTab}
                sequence={this.props.sequence}
                sequencePrimers={this.props.sequencePrimers}
                selection={this.props.selection}
                setSelection={this.props.setSelection}
                saveGuidePrimers={this.props.saveGuidePrimers}
                showGuidePrimers={this.props.showGuidePrimers}
                guideGroupSort={this.props.guideGroupSort}
                selectedGuideGroups={this.props.selectedGuideGroups}
              />,
            ];
          }
          return null;
        })()}
      </div>
    );
  }
}

const ConnectedCRISPRAnalysisTab = CRISPRAnalysisTabConnector.connect(CRISPRAnalysisTab);

class CRISPRAnalysisTabView extends Backbone.View<CRISPRAnalysisTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab';
  }

  initialize(options: unknown): void {
    this.setSelection = this.setSelection.bind(this);
    this.openAssemblyTab = this.openAssemblyTab.bind(this);
    this.openSequenceVersion = this.openSequenceVersion.bind(this);
    this.openExpandedTranslationView = this.openExpandedTranslationView.bind(this);
    const sequence = this.model.sequence();
    const _sequence = sequence._sequence();
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(sequence, 'change:writable change:permissions change:currentVersion', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(_sequence, 'change:annotations change:bases change:locked change:startIndex', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(_sequence.annotations(), 'add remove reset', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(sequence.selection(), 'change:start change:end', debounce(this.render, 250));
    this.listenTo(
      _sequence.sequencePrimers(),
      'add remove reset change:start change:end change:strand',
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.render
    );
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(sequence._sequence().translations(), 'add change remove reset', this.render);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    this.listenTo(sequence.get('versions'), 'sync', this.render);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type,@typescript-eslint/explicit-module-boundary-types
  saveGuidePrimers(folderId: string, nucleotideType: NucleotideType, tagSchemaId: string | undefined) {
    const sequence = this.model.sequence();
    const addPrimers = new biojs.SequencePrimerCollection([], {sequenceID: sequence.id});
    const guidePrimersList = Array.from(this.model.guidePrimers());
    for (const primer of guidePrimersList) {
      addPrimers.add({...primer.toJSON(), tagSchemaId, folder: folderId, nucleotideType});
    }
    return Backbone.sync('create', addPrimers, {fileUpdate: true} as JQueryAjaxSettings).done(
      ({primers, message}: {primers: Array<SequencePrimerAttributes>; message: string}) => {
        const addedPrimers = primers.map((data: SequencePrimerAttributes) => new biojs.SequencePrimer(data));
        sequence.updateVersions();
        this.model.resetGuidePrimers(addedPrimers, {empty: true});
        const notificationOptions = BenchlingConfig.ENABLE_BULK_ASSEMBLY
          ? {
              actionText: 'Open Bulk Assembly',
              onActionClick: openBulkAssembleDNA,
              duration: 10,
            }
          : {};
        notifications.success(message, notificationOptions);
      }
    );
  }

  showGuidePrimers(guides: Array<CRISPRGuide>): void {
    const sequence = this.model.sequence();
    const sequenceName = sequence.name();
    const sequenceLength = sequence.length();
    const startIndex = sequence.startIndex();
    const {analyses} = CRISPRAnalysisStore.getState();
    const analysis = analyses[this.model.analysisId()] as CRISPRAnalysis;
    this.model.resetGuidePrimers(
      guides.map((guide: CRISPRGuide) => {
        const start = CRISPRUtil.guideStart(guide, sequenceLength, analysis.isLeftPam);
        const end = CRISPRUtil.guideEnd(guide, sequenceLength, analysis.isLeftPam);
        return new biojs.SequencePrimer({
          start,
          end,
          strand: guide.strand,
          bases: guide.bases,
          pam: guide.pam,
          name: biojs.SequencePrimer.generateName(
            sequenceName,
            start,
            end,
            guide.strand === 1 ? 'forward' : 'reverse',
            sequenceLength,
            startIndex
          ),
        });
      })
    );
  }

  setSelection(start: number, end: number): void {
    const sequence = this.model.sequence();
    sequence.selection().setEndpoints(start, end);
    sequence.trigger('jump', start);
    this.render();
  }

  openAssemblyTab(analysis: CRISPRAnalysis, guides: Array<CRISPRGuide>): void {
    const sequenceFile = this.model.sequence().fileState();
    sequenceFile.buffers().addTab(
      new CRISPRAssemblyTabState({
        analysis,
        basesList: Array.from(guides).map((guide) => guide.bases),
        sequenceName: this.model.sequence().name(),
      })
    );
    analytics.track('crispr', 'started_assembly');
  }

  openSequenceVersion(versionId: number): void {
    const version = this.model.sequence().get('versions').get(versionId);
    if (version != null) {
      version.trigger('open', version);
    } else {
      this.model.sequence().fileState().get('toolbar').trigger('openHistoryPanel');
    }
  }

  openExpandedTranslationView(): void {
    (this.model.sequence().fileState() as SequenceFileState).openTranslationTabView();
  }

  render(): this {
    const sequence = this.model.sequence();
    const _sequence = sequence._sequence();
    const selection = sequence.selection();

    renderToDOM(
      <ConnectedCRISPRAnalysisTab
        allowEdits={sequence.allowFeatureEdits()}
        analysisId={this.model.analysisId()}
        annotations={sequence.annotations().map((annotation: Annotation) => ({
          start: annotation.start(),
          end: annotation.end(),
          name: annotation.name(),
        }))}
        /* eslint-disable-next-line @typescript-eslint/unbound-method */
        openAssemblyTab={this.openAssemblyTab}
        sequencePrimers={_sequence
          .sequencePrimers()
          .filter((sequencePrimer: biojs.SequencePrimer) => sequencePrimer.id != null)
          .map((sequencePrimer: biojs.SequencePrimer) => ({
            start: sequencePrimer.start(),
            end: sequencePrimer.end(),
            strand: sequencePrimer.strand(),
          }))}
        findGuidesParams={{sequence: this.model.sequence(), search: this.model.search()}}
        selection={{start: selection.start(), end: selection.end()}}
        /* eslint-disable-next-line @typescript-eslint/unbound-method */
        setSelection={this.setSelection}
        sequence={{
          id: sequence.id,
          bases: sequence.bases(),
          circular: sequence.circular(),
          length: sequence.length(),
          startIndex: sequence.startIndex(),
          translations: sequence.translations().toReactJSON(),
        }}
        saveGuidePrimers={this.saveGuidePrimers.bind(this)}
        showGuidePrimers={this.showGuidePrimers.bind(this)}
        /* eslint-disable-next-line @typescript-eslint/unbound-method */
        openSequenceVersion={this.openSequenceVersion}
        /* eslint-disable-next-line @typescript-eslint/unbound-method */
        openExpandedTranslationView={this.openExpandedTranslationView}
        versionIds={sequence.get('versions').pluck('id')}
      />,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<CRISPRAnalysisTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
CRISPRAnalysisTabView.initClass();

export {CRISPRAnalysisOptionsView, CRISPRAnalysisTabView};
